import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

import AgentQuickFilterDropdown from '@/components/agents-table/AgentQuickFilterDropdown.vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import CloudUnlock from '@/components/common/userNotifications/components/cloud-unlock.vue';
import { computed, inject, ref } from 'vue';
import { useUserRolePermissions } from '@/services/UserRolePermissions/UserRolePermissions';
import { CLOUD_STATUS, OFFLINE_STATUSES } from '@/views/settings/settingsCloud/cloud.const';
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import AgentRowHeightButton from '@/views/agents/components/agentRowHeightButton.vue';
import { IKAgentsDrawerFilter } from '@/types/injectionKeys';
import AddAgentsFreeDev from '@/components/common/userNotifications/components/add-agents-free-dev.vue';
import EditTable from '../../../edit-table/edit-table.vue';
import navBarStatusBar from '../components/nav-bar-status-bar.vue';
import NavBarMultipleActionsBtn from '../components/nav-bar-multiple-actions-btn.vue';
import NavBarFilterBtn from '../components/nav-bar-filter-btn.vue';
import NavBarSearchInput from '../components/nav-bar-search-input.vue';
import NavBarShowStatusBar from '../components/nav-bar-show-status-bar.vue';
import ManageBuildGroups from '../../../manage-build-groups-btn.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'agents-nav-bar-list.windows',
  setup(__props) {

const coordinatorService = inject(IKCoordinatorsService);
const agentsFilter = inject(IKAgentsDrawerFilter);
const GQL_commonData = useCommonDataQuery(() => ({ coordinatorId: coordinatorService?.selectedCoordinator.value || '' }));
const cloudStatus = computed(() => (GQL_commonData?.result?.value?.ibManagerEntities?.settings?.common?.cloud?.cloudStatus as CLOUD_STATUS) || CLOUD_STATUS.Disabled);
const showAddAgentsButton = computed(
  () => GQL_commonData?.result?.value?.ibManagerEntities?.license?.windows?.isFreeTrial || GQL_commonData?.result?.value?.ibManagerEntities?.license?.windows?.isFreeDev,
);

const userRolePermissions = useUserRolePermissions();
const cloudIsOffline = computed(() => OFFLINE_STATUSES.has(cloudStatus.value));
const showCloudUnlock = computed(() => (showAddAgentsButton.value ? false : userRolePermissions.authorize?.value?.cloud.visible.unlockCloud && cloudIsOffline));

const setIsTopDashboardVisible = () => {
  const topDashboardVisibleValue = localStorage.getItem('top-dashboard-visible-agents');
  // When we enter UI first time top-dashboard-visible-agents do not exist in localStorage so when calling getItem return null
  return topDashboardVisibleValue === null || topDashboardVisibleValue === 'true';
};
const isTopDashboardVisible = ref(false);

isTopDashboardVisible.value = setIsTopDashboardVisible();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(navBarStatusBar, {
        "is-top-dashboard-visible": isTopDashboardVisible.value,
        onToggleTopDashboard: _cache[0] || (_cache[0] = (value)=> isTopDashboardVisible.value = value)
      }, null, 8, ["is-top-dashboard-visible"]),
      _createElementVNode("div", {
        class: _normalizeClass(["agents-table-nav gap-[12px]", { 'mt-[16px]': isTopDashboardVisible.value }])
      }, [
        _createVNode(NavBarMultipleActionsBtn),
        _createVNode(NavBarFilterBtn),
        _createVNode(AgentQuickFilterDropdown, {
          class: "table-upper-buttons",
          "quick-filter-state": _unref(agentsFilter)?.filter.value?.quickFilter as any
        }, null, 8, ["quick-filter-state"]),
        _createVNode(NavBarSearchInput),
        _createElementVNode("div", {
          class: _normalizeClass(["flex agents-nav-items ml-auto flex-nowrap gap-[12px]", {
          'nav-status-bar-open-mode': isTopDashboardVisible.value,
          'nav-status-bar-close-mode': !isTopDashboardVisible.value,
        }])
        }, [
          (_unref(userRolePermissions).authorize?.value?.agents?.visible?.buildGroupsButton)
            ? (_openBlock(), _createBlock(ManageBuildGroups, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(EditTable),
          _createVNode(AgentRowHeightButton),
          (_unref(showCloudUnlock))
            ? (_openBlock(), _createBlock(CloudUnlock, { key: 1 }))
            : _createCommentVNode("", true),
          (_unref(showAddAgentsButton))
            ? (_openBlock(), _createBlock(AddAgentsFreeDev, { key: 2 }))
            : _createCommentVNode("", true),
          _createVNode(NavBarShowStatusBar, {
            "is-top-dashboard-visible": isTopDashboardVisible.value,
            onToggleTopDashboard: _cache[1] || (_cache[1] = (value)=> isTopDashboardVisible.value = value)
          }, null, 8, ["is-top-dashboard-visible"])
        ], 2)
      ], 2)
    ]),
    _: 1
  }))
}
}

})